import { scrollIntoView } from '@/utils/scrollToElement'

/**
 * Handles the click event on an anchor element.
 * Prevents the default behavior and navigates to the anchor's target.
 *
 * @param e - The event object from the click event.
 * @param router - The router object used to navigate.
 */
export const handleAnchorClick = (e: any, router: any) => {
  e.preventDefault()

  if (e.currentTarget?.hash) {
    const anchorId = e.currentTarget.hash.split('#')[1]
    router.push('#' + anchorId)

    scrollIntoView(anchorId)
  }
}
